// @flow
/* eslint-disable import/prefer-default-export */

export const UA_SESSION_TOKEN = "ua_session_token"
export const EXPIRY_DAYS = 30

export const KW_AUTH_TOKEN = "kwAuthToken"

export const ONE_TIME_ERROR_KEYS = {
  "Booking not found": __("account.my_booking_login_incorrect"),
}

export const RAW_ERROR_KEYS = {
  // Signup
  "Password is too short.": __("account.password_too_short"),
  "Password has a pattern.": __("account.password_has_pattern"),
  "Password is too common.": __("account.password_too_common"),
  "Password is too simple.": __("account.password_too_simple"),

  "Invalid email verification token.": __("account.invalid_email_verification_token"),

  // Login
  "Login failed.": __("account.login_failed"),
  "User is not verified.": __("account.user_is_not_verified"),
  "You are temporarily blocked from other login attempts.": __(
    "account.user_temporarily_blocked_from_login",
  ),

  // Edit
  "Password does not match the current password.": __("account.pass_does_not_match_current_pass"),
  "Invalid password reset token.": __("account.invalid_password_reset_token"),
}
